import { render, staticRenderFns } from "./EditCompany.vue?vue&type=template&id=3f5b3bb5&scoped=true"
import script from "./EditCompany.vue?vue&type=script&lang=js"
export * from "./EditCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5b3bb5",
  null
  
)

export default component.exports